export default __webpack_public_path__ + "static/media/shinobi-black.9bb7fff1.svg";